export function animationCircle(posX, posY, parent, element){
  const divDin = element.cloneNode();
  divDin.style.left=(posX+"px");
  divDin.style.top=(posY+"px");
  divDin.className="buttonAnimation";
  parent.appendChild(divDin);
  setTimeout(function() { divDin.parentNode.removeChild(divDin); }, 1500);
}



// WEBPACK FOOTER //
// ./src/js/animations.js